<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  *ngIf="!showMessage"
>
  <app-content-header text="Remove Camper"></app-content-header>
  <p
    class="lato"
    style="font-size: 0.875rem"
  >
    We’re sorry we’ll no longer see your pup at Camp. If you’re willing to share,
    please let us know the reason you are removing this Camper.
  </p>
  <mat-radio-group
    formControlName="survey"
    class="d-flex flex-column"
  >
    <mat-radio-button [value]="surveyOptions.NO_LONGER_ATTENDING">My dog is no longer attending Camp</mat-radio-button>
    <div
      *ngIf="f.survey.value === surveyOptions.NO_LONGER_ATTENDING"
      class="input-container"
    >
      <span class="input-label">Reason dog is no longer attending (optional)</span>
      <textarea
        formControlName="reasonMsg"
        class="input h-auto"
        rows="5"
      ></textarea>
    </div>
    <mat-radio-button [value]="surveyOptions.DECEASED">My dog has passed away</mat-radio-button>
    <div
      *ngIf="f.survey.value === surveyOptions.DECEASED"
      class="input-container"
    >
      <span class="input-label">Message for Camp (optional)</span>
      <textarea
        formControlName="deceasedMsg"
        class="input h-auto"
        rows="5"
      ></textarea>
    </div>
  </mat-radio-group>
  <div class="action-container">
    <button
      type="submit"
      class="btn btn-danger btn-block"
      [disabled]="!form.valid"
    >
      Submit
    </button>
  </div>
</form>
<div *ngIf="showMessage">
  <div class="row no-gutters">
    <div class="col d-flex justify-content-center">
      <img
        src="assets/images/ico_remove dog_heart.png"
        alt="Sorry for your loss"
        height="120"
      />
    </div>
  </div>
  <div
    class="row no-gutters mb-4"
    style="margin-top: 2rem"
  >
    <div
      class="col d-flex justify-content-center lato blue"
      style="font-size: 1.5rem"
    >
      {{ isDeceased ? "We are thinking of you" : "Thank you" }}
    </div>
  </div>
  <div class="row no-gutters">
    <div
      class="col d-flex justify-content-center lato text-center"
      style="font-size: 0.875rem"
    >
      <span *ngIf="isDeceased; else elseBlock">
        We are very sorry about the passing of <b>{{ petName }}</b>. Our Pack won't be the same without your sweet pup.
      </span>
      <ng-template #elseBlock>
        <span>It's always hard to lose part of our Pack. We wish
          <b>{{ petName }}</b> the very best.</span>
      </ng-template>
    </div>
  </div>
  <div class="action-container">
    <button
      type="button"
      class="btn btn-danger btn-block"
      (click)="navigateToLandingPage()"
    >
      Return Home
    </button>
  </div>
</div>
